/* tslint:disable */
export var icon = "\n<svg width=\"12\" height=\"10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.5 5H2m0 0l4 4M2 5l4-4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg>\n";
//# sourceMappingURL=back-arrow.svg.js.map